import { render, staticRenderFns } from "./Preparations.vue?vue&type=template&id=60c1c617&"
import script from "./Preparations.vue?vue&type=script&lang=js&"
export * from "./Preparations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Preparations.vue"
export default component.exports